import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Icons for expand/collapse
import "./Faq.css"; // FAQ styles
import { faq } from "../content"; // Import FAQ data

const Faq = () => {
  return (
    <div className="fade-in">
      <div className="container">

        {/* Hero image section */}
        <div className="faq-image">
          <div className="hero-text content-wrapper">
            <h1 className="title">FAQs</h1>
          </div>
        </div>

        {/* FAQ List */}
        <div className="faq-list">
          {faq.map((item, index) => (
            <FaqItem key={index} question={item.question} answer={item.answer} />
          ))}
        </div>

      </div>
    </div>
  );
};

// Each individual FAQ item with toggle logic
const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false); // Track open/close state

  const toggleOpen = () => {
    setIsOpen(!isOpen); // Toggle state
  };

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={toggleOpen}>
        <span>{question}</span>
        {/* Display appropriate icon depending on toggle state */}
        {isOpen ? <FaChevronUp className="faq-icon" /> : <FaChevronDown className="faq-icon" />}
      </div>
      {/* Show answer only if open; use dangerouslySetInnerHTML for links */}
      {isOpen && (
        <div className="faq-answer" dangerouslySetInnerHTML={{ __html: answer }} />
      )}
    </div>
  );
};

export default Faq;
